module.exports = __webpack_public_path__ + "img/cxTrends-15.bdb3837b.png";